import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import Chip from '@material-ui/core/Chip';
import './localidadesEntrega.css';

const styles = ({
    root: {
        minWidth: 275,
        margin: 10,
        cursor: 'default'
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold'
    },
    pos: {
        marginBottom: 12,
    },
    icon: {
        position: 'absolute',
        right: 0,
        top: 0,
    },
    activeChip: {
        marginLeft: 10,
        backgroundColor: '#4caf50',
        color: 'white'
    },
    inactiveChip: {
        marginLeft: 10,
        backgroundColor: '#f44336',
        color: 'white'
    },
});

class Item extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
        };
    }

    handleClick = (event) => {
        event.stopPropagation();
        this.setState({ anchorEl: event.currentTarget });
    };

    handleClose = (event) => {
        if (event) {
            event.stopPropagation();
        }
        this.setState({ anchorEl: null });
    };

    handleMenuItemClick = (handler, event) => {
        if (event) {
            event.stopPropagation();
        }
        this.handleClose();
        handler();
    }

    handleCardClick = (onClick) => {
        if (!this.state.anchorEl) {
            onClick();
        }
    }

    render() {
        const { classes, item, mapToItem } = this.props;
        const { anchorEl } = this.state;
        const open = Boolean(anchorEl);
        const mappedItem = mapToItem(item);

        return (
            <Card 
                className={classes.root} 
            >
                <CardContent>
                    <div style={{ position: 'relative' }}>
                        <Typography className={classes.title} color="textPrimary" gutterBottom>
                            <LocationOnIcon style={{ verticalAlign: 'middle', marginRight: '5px' }} />
                            {item.descripcion}
                            <Chip
                                size="small"
                                label={item.estado ? 'Activo' : 'Inactivo'}
                                className={item.estado ? classes.activeChip : classes.inactiveChip}
                                disabled={false}
                                clickable={false}
                            />
                        </Typography>
                        
                        <IconButton 
                            className={classes.icon}
                            aria-label="more"
                            aria-controls="long-menu"
                            aria-haspopup="true"
                            onClick={this.handleClick}
                        >
                            <MoreVertIcon />
                        </IconButton>
                        
                        <Menu
                            id="long-menu"
                            anchorEl={anchorEl}
                            keepMounted
                            open={open}
                            onClose={this.handleClose}
                            onClick={(e) => e.stopPropagation()}
                        >
                            {mappedItem.opciones.map((opcion, index) => (
                                <MenuItem 
                                    key={index} 
                                    onClick={(e) => this.handleMenuItemClick(opcion.handler, e)}
                                >
                                    {opcion.nombre}
                                </MenuItem>
                            ))}
                        </Menu>
                    </div>
                    
                    <Typography variant="body2" component="p">
                        Código: {item.nombre}
                    </Typography>
                </CardContent>
            </Card>
        )
    }
}

Item.propTypes = {
    classes: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
    mapToItem: PropTypes.func.isRequired,
};

export default withStyles(styles)(Item);